import * as React from "react";

export default class FeatureDisabled extends React.Component {
    render() {
        return (
            <div className="container-fluid body-content feature-disabled-container">
                <div className="row">
                    <div className="col-12 maxWidth-content">
                        <div className="section-error-container">
                            <div className="row">
                                <div className="col-12 align-self-center">
                                    <div className="row section-error__header">
                                        <div className="col-12">
                                            <div className="section-error__header--title">
                                                <span className="icon-important" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row section-error__body">
                                        <div className="col-12">
                                            <div className="section-error__body--message">
                                                <span className="message-text">Not available. Please try again later.</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}